import { CloseRounded } from '@mui/icons-material';
import {
    AppBar,
    Divider,
    Drawer,
    IconButton,
    Stack,
    Toolbar,
    Typography,
} from '@mui/material';
import ProfilHeader from './profile-header';
import ContactInfoCard from '@Views/Contacts/Contacts/ContactDetails/Components/ContactInfoCard';
import { omit } from 'lodash';
import { useQuery } from '@tanstack/react-query';
import { contactQueryOptions } from '@utils/queryOptions';

const ContactSidePan = ({ contactId, open, onClose }) => {
    const { data: contact, isLoading } = useQuery(
        contactQueryOptions(contactId),
    );

    return (
        <Drawer
            anchor="right"
            variant="temporary"
            PaperProps={{ sx: { width: 300, bgcolor: 'surface.main' } }}
            open={open}
            onClose={onClose}
            slotProps={{ backdrop: { sx: { bgcolor: 'unset' } } }}
            transitionDuration={50}
            elevation={4}
        >
            <AppBar position="sticky" sx={{ bgcolor: 'surface.main' }}>
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Typography variant="titleMedium">
                        Contact Details
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseRounded />
                    </IconButton>
                </Toolbar>
                <Divider />
            </AppBar>
            {isLoading ? (
                <h2>Loading...</h2>
            ) : (
                <>
                    <ProfilHeader contact={contact} />
                    <Stack spacing={2} sx={{ p: 3 }}>
                        <ContactInfoCard
                            contact={omit(
                                contact,
                                'description',
                                'created',
                                'updated',
                            )}
                            sx={{ bgcolor: 'surfaceContainerLow.main' }}
                        />
                    </Stack>
                </>
            )}
        </Drawer>
    );
};

export default ContactSidePan;
